import { httpClient } from '@/api/http-client'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
type CreateContractParams = {
  deal_key: string
}

const createContract = async (
  params: CreateContractParams,
): Promise<{ code: string }> => {
  const response = await httpClient('accounting-dealer').post<{ code: string }>(
    `/v3/contract/${params.deal_key}`,
  )

  return response.data
}

export const useCreateContract = (
  { deal_key }: CreateContractParams,
  options?: Partial<UseMutationOptions<{ code: string }>>,
) => {
  return useMutation({
    mutationFn: () => createContract({ deal_key }),
    ...options,
  })
}
